import { useEffect, FC, ReactNode, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

interface GuestGuardProps {
  children: ReactNode;
}

const AuthGuard: FC<GuestGuardProps> = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user, isLoggedIn } = useSelector((state: any) => state.commonSlice);
  const [userType, setUserType] = useState(user?.userType);
  const fullUrl = location.pathname + location.search;
  

  useEffect(() => {
    setUserType(user?.userType);
  },[user]);

  // removed local storage initialization

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     sessionStorage.removeItem("redirectURL");
  //     sessionStorage.removeItem("redirectInProgress");
  //   }
  // }, [isLoggedIn]);

  if (isLoggedIn) {
    // If user is virtual user
    if(userType === "VRU") {
      if(fullUrl.includes('/app/events') || fullUrl.includes('/app/userProfileEdit')) {
        return <>{children}</>;
      }
      else {
        return <Navigate to="/app/events/eventRegistration" />;
      }
    }
    // For normal users
    else {
      return <>{children}</>;
    }
  }
  // If non-logged in user is trying to access any event page, redirect the user to event-login page.
  else if(fullUrl.includes('/eventLogin') || fullUrl.includes('/events')) {
    return <Navigate to='/eventLogin' />
  }
  else {
    if(fullUrl !== '/login')  sessionStorage.setItem('redirectURL', fullUrl);
    return <Navigate to='/login' />;
  }
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;